import { Component, OnInit } from '@angular/core';
import { AddService } from '../shared/services/userservices/add.service';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DashboardService } from '../shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from '../shared/services/shared-mode.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../shared/components/loader/loader.component';
@Component({
  selector: 'app-event-management',
  templateUrl: './event-management.component.html',
  styleUrls: ['./event-management.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
})
export class EventManagementComponent implements OnInit {
  [x: string]: any;
  public showSpinner = false;
  apidata: any;
  data_type: any;
  isupComing = true;
  isPast = false;
  pastdata: any;
  upComing: any;
  constructor(
    private addService: AddService,
    public router: Router,
    private route: ActivatedRoute,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,


  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {
    this.ShownEventData();
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }

  showupComing() {
    this.isupComing = true;
    this.isPast = false;
  }
  // tabs funtion
  showPastevent() {
    this.isupComing = false;
    this.isPast = true;
    this.data_type = 'past_events'
    this.addService.showEventDetail(this.data_type).then((value) => {
      this.pastdata = value.data.past_events
      this.showSpinner = false;

    });
  }
  ShownEventData() {
    this.showSpinner = true;
    this.data_type = 'upcoming_events'
    this.addService.showEventDetail(this.data_type).then((value) => {
      this.apidata = value.data.upcoming_events
      this.showSpinner = false;

    });
  }
  replaceUnderscores(value: string): string {
    return value.replace(/_/g, ' ');
  }
  deleteevent(id: any) {
    this.showSpinner = true;

    const selected_id = id
    this.addService.deleteEvent(selected_id).then((value) => {
      this.showSpinner = false;
    });
  }
  editeevent(id: any) {
    this.showSpinner = true;
    const selected_id = id

    this.router.navigate(['/create-event', selected_id]);

    this.showSpinner = false;





  }

  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data;
      this.user = this.userInfo;
      this.colormode = this.userInfo.color_mode;
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }


  isavailablefeature(type: string): boolean {
    switch (type) {
      case "isView":
        var user_role = JSON.parse(this.user.user_role.user_roles);
        return !user_role.event_data.data.values.view === false
      case "isAdd":
        var user_role = JSON.parse(this.user.user_role.user_roles);
        return !user_role.event_data.data.values.add === false
      case "isEdit":
        var user_role = JSON.parse(this.user.user_role.user_roles);
        return !user_role.event_data.data.values.edit === false
      case "isDelete":
        var user_role = JSON.parse(this.user.user_role.user_roles);
        return !user_role.event_data.data.values.delete === false
      default:
        return false;


    }
    return false
  }

}
